import React from "react";
import { changeHotel, formatDatesFromTo, isCurrentHotel } from "./functions";
import { formatRublePrice } from "../../../../universal";
import Spinner from "../../../shared/spinner";
import { names } from "../../../../Styles/names";
import { ChangeHotelButton } from "./ChangeHotelButton";

export default function HotelCard598({
  hotel,
  minPrice,
  stars,
  imagePath,
  conveniences,
  date_in,
  date_out,
  isMinPriceLoaded,
}) {
  return (
    <div className={`hotellist-modal__hotel-block ${names.backgrond.secondary}`} key={hotel.name}>
      <div className="hotellist-modal__hold-head-598">
        <div className="hotellist-modal__hotel-image">
          <img alt="hotel_pic" src={imagePath} />
        </div>
        <div className="hotellist-modal__hotel-name-wrap">
          <div className={`hotellist-modal__hotel-name ${names.text.primary}`}>{hotel.name}</div>
          <div className="hotellist-modal__hotel-stars">
            {Array.from({ length: stars }, (v, i) => i).map((_, i) => (
              <div key={i} className="hotellist-modal__hotel-star"></div>
            ))}
          </div>
        </div>
      </div>

      <div className="hotellist-modal__hotel-description">
        {hotel.description}
      </div>
      <div className="hotellist-modal__hotel-services">
        {conveniences.map((it, i) => (
          <>
            <span className={names.text.secondary}>{it}</span>
            {i + 1 === conveniences.length ? "" : " • "}
          </>
        ))}
      </div>
      {!isMinPriceLoaded ? (
        <div className="hotellist-modal__hotel-loader">
          <Spinner />
        </div>
      ) : (
        <div className="hotellist-modal__hotel-hold">
          <div className="hotellist-modal__hotel-price-hold">
              <div className={`hotellist-modal__hotel-price ${names.text.primary}`}>
              {!minPrice ? "__" : "от " + formatRublePrice(minPrice || 0)}
            </div>
              <div className={`hotellist-modal__hotel-date ${names.text.tertiary}`}>
              {formatDatesFromTo(date_in, date_out)}
            </div>
          </div>

            <ChangeHotelButton hotel={hotel} minPrice={minPrice} />
        </div>
      )}
    </div>
  );
}
